import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

export const AGGREGATED_CAMPAIGNS_ROUTES: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'one-off',
    },
    {
        path: 'one-off',
        loadChildren: () => import('#modules/crm/campaigns/routes/crm-campaigns.routes').then((m) => m.CRM_CAMPAIGNS_ROUTES),
        data: { routePath: RoutePath.ONE_OFF_CAMPAIGNS },
    },
];
